<template>
  <div class="diaries">
    <div class="wrap">
      <div class="list-group">
        <div class="list">
          <list-item v-for="diary in first_n" :item=diary v-bind:key=diary.key></list-item>
        </div>
        <div class="list">
          <list-item v-for="diary in next_n" :item=diary v-bind:key=diary.key></list-item>
        </div>
      </div>
      <div class="content">
        <content-section :content="content"></content-section>
      </div>
    </div>
  </div>
</template>

<script>
import ListItem from '../common/ListItem'
import ContentSection from '../common/Content'
const markdown_content = `
  ##Welcome to my diary.

  These pages allow me to share information about my active projects, experiments, ideas, and adventures. 
  For short and quick updates about what I'm up to, check out my [Twitter](https://www.twitter.com/lyninxmusic).
`
export default {
  components: { ListItem, ContentSection },
  data: () => {
    return {
      message: "",
      num_diaries: 4,
      content: { 'type': 'markdown', 'data': markdown_content }
    }
  },
  computed: {
    diaries() {
      return this.$store.state.diaries.filter((d) => d.published)
    },
    first_n() {
      return this.diaries.slice(0, this.num_diaries)
    },
    next_n() {
      return this.diaries.slice(this.num_diaries)
    }
  },
  created: function() {
    this.$store.dispatch('clearMeta').then(() => {
      this.$store.dispatch('fetchDiaries').then(() => {
        let diary_with_image = this.diaries.find((d) => {
          return d.image.key != null
        })
        if (diary_with_image) {
          this.$store.dispatch('setImage', diary_with_image.image)
        } else {
          this.$store.dispatch('clearImage')
        }
      }, () => {
        // 404 
      })
    })

  }
}
</script>
